import React from "react";
import CollapsibleCard from "../../../ForBrands/ui/CollapsibleCard";
import { LegendRow } from "../../../ForBrands/ui/LegendItem";
import { CHART } from "../../../ForBrands/ui/charts/chartTokens";
import { ListRule } from "../../../ForBrands/ui/mobile/MobileUI";
import { usePhoneTheme } from "../../../ForBrands/useIsPhone";
import { StatMetric, TeamComparison } from "../profileSections";
import { LegendDot } from "../mobile/mobileProfileSections";
import { SubHead } from "./perfPieces";

// Peers and teammates (spec B3 g): the profile's own comparisons, which sat
// in the Current season card (Kobi's 10/2 work), in a card of their own now
// that Game by Game draws the season: the athlete against the team's
// average with the team ranks (vs. teammates), then against the peer
// group's average with the percentile row (vs. peer group). Each in the
// look the Current season card gave it: the legend pills over the chart on
// desktop (the section's legend row), the legend dots under it on phones
// (2020:1950). `view` is athletePerformanceModel.peersView().

const PeerRows = ({ comparison, phone }) => {
  if (!comparison.tiles?.length) return null;
  if (!phone) {
    return (
      <div className="flex flex-col gap-[10px] sm:flex-row">
        {comparison.tiles.map((t) => (
          <StatMetric key={t.label} label={t.label} value={t.value} chip={t.chip} />
        ))}
      </div>
    );
  }
  return (
    <>
      <ListRule />
      <div className="flex flex-col gap-[14px]">
        {comparison.tiles.map((t) => (
          <div key={t.label} className="flex items-center gap-3">
            <div className="flex min-w-0 flex-1 flex-col gap-[2px] break-words">
              <p className="bm-overline">{t.label}</p>
              {t.chip?.label && <p className="bm-body-xs text-bm-muted">{t.chip.label}</p>}
            </div>
            <span className="shrink-0 whitespace-nowrap bm-num-m text-bm-ink">{t.value}</span>
          </div>
        ))}
      </div>
    </>
  );
};

const PeersTeammatesCard = ({ view, cardProps = {} }) => {
  const phone = usePhoneTheme();
  const { teammates, comparison, you } = view;
  return (
    <CollapsibleCard title="Peers and teammates" subtitle={view.lede} {...cardProps}>
      {teammates && (
        <div className="flex flex-col gap-3">
          <SubHead>vs. teammates</SubHead>
          {!phone && (
            <LegendRow
              label="Teammates legend"
              items={[
                { key: "you", swatch: "dot", color: CHART.orange, label: you },
                { key: "team", swatch: "dot", color: CHART.strong, label: "Team avg" },
              ]}
            />
          )}
          <TeamComparison teammates={teammates} label={you} compact={phone} />
          {phone && (
            <div className="flex flex-wrap gap-x-[14px] gap-y-1">
              <LegendDot tone="bg-bm-orange">{you}</LegendDot>
              <LegendDot tone="bg-bm-strong">Team avg</LegendDot>
            </div>
          )}
        </div>
      )}
      {comparison && (
        <div className="flex flex-col gap-3">
          <SubHead>vs. peer group</SubHead>
          {comparison.caption && <p className={phone ? "bm-body-xs text-bm-muted" : "bm-body-s text-bm-muted"}>{comparison.caption}</p>}
          <PeerRows comparison={comparison} phone={phone} />
        </div>
      )}
    </CollapsibleCard>
  );
};

export default PeersTeammatesCard;
